import React from "react";
import "./footer.styles.css";

export const Footer = () => {
    return(
        <footer className="footer">
            <p>Data provided by <a href="https://coinranking.com">Coinranking</a></p>
            <p>Made by <a href="https://github.com/allangabrielrod">allangabrielrod</a></p>
        </footer>
    );
}